import React from "react";
import CodeExample from "../partials/content/CodeExample";
import { Table } from "react-bootstrap";
import { getAccounts,getBusinessEntities,getWidgetData } from "../crud/auth.crud";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../partials/content/Portlet";
 import { Link } from "react-router-dom";


export default class AccountTiles extends React.Component {
  state = {
    accounts:[],
    businessEntities:[],
    widget:{}

  }
  componentDidMount()
  {
    
    getAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
      //console.log("accocunt::::",data);
     })
    getBusinessEntities().then(response => response.data)
    .then((data) => {
      this.setState({ businessEntities: data })
      //alert('Business found:'+data.length)
      //console.log('Business : ',data)
     })
    getWidgetData().then(response => response.data)
    .then((data) => {
      this.setState({ widget: data })
      //alert('Business found:'+data.length)
      //console.log('Business : ',data)
     })
  }
  render() {
    return (
      <>

         <div className="row">
        
        <div className="col-xl-12">
          <div className="row">
           {this.state.businessEntities.map((entity,index) => (
            <div className="col-lg-3" key={"bb"+index}>
              <Link to={{pathname:"/account", data: entity.description}}>
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {this.state.accounts.filter(acc=> acc.businessEntity==entity.description).length}
                      </span>
                      <span className="kt-widget26__desc">{entity.description}</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
              </Link>
             </div>
            ))}
            <div className="col-lg-3">
              <Link to="/account">
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {(Math.round(this.state.widget.storage/1024/1024/1024,2) == 0 ? '0.1' : Math.round(this.state.widget.storage/1024/1024/1024,2))}
                      </span>
                      <span className="kt-widget26__desc">Total Storage (in GB)</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
              </Link>
             </div>
             <div className="col-lg-3">
             <Link to="/user">
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {this.state.widget.activeUsers}
                      </span>
                      <span className="kt-widget26__desc">Active Users</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
              </Link>
             </div>
             <div className="col-lg-3">
             <Link to="/user">
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {this.state.widget.disabledUsers}
                      </span>
                      <span className="kt-widget26__desc">Disabled Users</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
              </Link>
             </div>
             <div className="col-lg-3">
              <Link to="/approval">
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {this.state.widget.pendingApproval}
                      </span>
                      <span className="kt-widget26__desc">Pending Approval</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
              </Link>
             </div>
             <div className="col-lg-3">
              <Portlet className="kt-portlet--border-bottom-brand">
                <PortletBody fluid={true}>
                  <div className="kt-widget26">
                    <div className="kt-widget26__content">
                      <span className="kt-widget26__number"> 
                        {this.state.widget.supportTickets}
                      </span>
                      <span className="kt-widget26__desc">Support Tickets</span>
                    </div>
                  </div>
                </PortletBody>
              </Portlet>
             </div>
          </div>
        </div>
        
        
      </div>
       
      </>
    );
  }
}
